import {
  getAllProps,
  getRequiredComponentElements,
} from "../../../scripts/utils/utility";
import * as styles from "bundle-text:./contact.scss";
import templateHTML from "bundle-text:./template.html";
import { sendMail } from "../../../scripts/email";

export class ContactComponent extends HTMLElement {
  private props: Map<string, string>;
  private propNames = {};
  private ComponentElements: Map<string, HTMLElement>;
  private ComponentNames = {
    form: "#feedbackForm",
    success: ".success",
    error: ".error",
    name: `input[name='name']`,
    email: `input[name='email']`,
    subject: `input[name='subject']`,
    message: `textarea[name='message']`,
    button: "button",
  };

  private template = () => `
   <style>${styles}</style>
   ${templateHTML}
  `;
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.props = getAllProps(this);
    this.render();
    this.ComponentElements = getRequiredComponentElements(
      this,
      this.ComponentNames
    );
  }

  connectedCallback() {
    const formElement = this.ComponentElements.get(this.ComponentNames.form);

    if (formElement) {
      formElement.addEventListener("submit", this);
    }
  }
  private disableSubmitButton() {
    const button = this.ComponentElements.get(this.ComponentNames.button);
    if (button) {
      button.classList.add("disable");
    }
  }

  private enableSubmitButton() {
    const button = this.ComponentElements.get(this.ComponentNames.button);
    if (button) {
      button.classList.remove("disable");
    }
  }

  handleEvent(ev: Event) {
    ev.preventDefault();
    this.disableSubmitButton();
    const nameEle = this.ComponentElements.get(
      this.ComponentNames.name
    ) as HTMLInputElement;
    const emailEle = this.ComponentElements.get(
      this.ComponentNames.email
    ) as HTMLInputElement;
    const subjectEle = this.ComponentElements.get(
      this.ComponentNames.subject
    ) as HTMLInputElement;
    const messageEle = this.ComponentElements.get(
      this.ComponentNames.message
    ) as HTMLInputElement;

    const attrs = {
      name: nameEle.value || "NA",
      email: emailEle.value || "NA",
      message: messageEle.value || "NA",
      subject: subjectEle.value || "NA",
    };
    this.sendMail(attrs);
    this.enableSubmitButton();
  }
  private resetFrom() {
    const form = this.ComponentElements.get(
      this.ComponentNames.form
    ) as HTMLFormElement;
    form.reset();
  }

  private async sendMail(
    attrs: {
      name?: string;
      email?: string;
      message?: string;
      subject?: string;
    } = {}
  ) {
    const mailStatus = await sendMail(attrs);
    if (mailStatus) {
      const success = this.ComponentElements.get(
        this.ComponentNames.success
      ) as HTMLElement;
      success.style.display = "block";
      setTimeout(() => {
        success.style.transition = "all 400ms ease";
        success.style.display = "none";
        this.resetFrom();
      }, 2000);
    } else {
      const error = this.ComponentElements.get(
        this.ComponentNames.error
      ) as HTMLElement;
      error.style.display = "block";
      setTimeout(() => {
        error.style.transition = "all 400ms ease";
        error.style.display = "none";
        this.resetFrom();
      }, 2000);
    }
  }

  disconnectedCallback() {
    const formElement = this.ComponentElements.get(this.ComponentNames.form);

    if (formElement) {
      formElement.removeEventListener("submit", this);
    }
  }

  render() {
    if (this.shadowRoot) {
      this.shadowRoot.innerHTML = this.template().trim();
    }
  }
}

customElements.define("contact-component", ContactComponent);
